import './style.css';

import React from 'react';

function Wrapper(props) {
  return <main className="wrapper" {...props} />;
}

export default Wrapper;